import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { sendSellerQuoteBid } from '../../services/sellerQuote'
import { onAddOfferSuccess } from '../QuoteBidSeller/QuoteBidSeller.actions'
import { translateErrorCodeQuoteResponse } from './SendSellerQuoteDialog.utils'

export const SHOW_SEND_SELLER_QUOTE_DIALOG = 'SHOW_SEND_SELLER_QUOTE_DIALOG'
export const onShowSendSellerQuoteDialog = makeActionCreator(SHOW_SEND_SELLER_QUOTE_DIALOG, 'payload')

export const CLOSE_SEND_SELLER_QUOTE_DIALOG = 'CLOSE_SEND_SELLER_QUOTE_DIALOG'
export const onCloseSendSellerQuoteDialog = makeActionCreator(CLOSE_SEND_SELLER_QUOTE_DIALOG, {})

export const ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID = 'ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID'
export const ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_ERROR = 'ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_ERROR'
export const ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_SUCCESS = 'ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_SUCCESS'
export const onAcceptAndPublishSellerQuoteBid = makeActionCreator(ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID)
export const onAcceptAndPublishSellerQuoteBidError = makeActionCreator(
  ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_ERROR,
  'payload'
)
export const onAcceptAndPublishSellerQuoteBidSuccess = makeActionCreator(
  ACCEPT_AND_PUBLISH_SELLER_QUOTE_BID_SUCCESS,
  'payload'
)
export const onAcceptAndPublishSellerQuoteBidThunk = payload => async (dispatch, getState) => {
  dispatch(onAcceptAndPublishSellerQuoteBid())

  const { quoteBidSeller } = getState().quoteBidSeller

  try {
    const { data } = await sendSellerQuoteBid({ quoteBidSeller: { ...quoteBidSeller, userHost: payload.userHost } })

    batch(() => {
      dispatch(
        onAcceptAndPublishSellerQuoteBidSuccess({
          payload: data.payload,
          success: data.success
        })
      )
      dispatch(onAddOfferSuccess({ addOffer: false }))
      payload.callback()
    })
  } catch (error) {
    const errores = error?.originalError?.response?.data?.errores
    const err =
      Array.isArray(errores) && errores.length
        ? errores.map(e => translateErrorCodeQuoteResponse(e))
        : [translateErrorCodeQuoteResponse(error)]

    return dispatch(onAcceptAndPublishSellerQuoteBidError({ error: err }))
  }
}

export const HIDE_ERRORS_SEND_SELLER_QUOTE_DIALOG_SUCCESS = 'HIDE_ERRORS_SEND_SELLER_QUOTE_DIALOG_SUCCESS'
export const onHideErrorsSendSellerQuoteDialogSuccess = makeActionCreator(
  HIDE_ERRORS_SEND_SELLER_QUOTE_DIALOG_SUCCESS,
  'payload'
)
